<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div>
        <div v-if="role===0 || role===1" class="table-top-wrapper">
            <el-row>
                <el-col :span="24" class="condition-panel"
                        style="display: flex;flex-direction: row;justify-content: space-between;">
                    <el-col :span="2">
                    </el-col>
                    <el-col :span="22" style="display: flex;flex-direction: row;justify-content: end;">
                        <el-form :inline="true">
                            <!--HH:mm:ss-->
                            <el-form-item label="用户ID" style="margin-right: 10px !important;">
                                <el-input @input="getTrend(true)" v-model="trendSelect.trend.userId"
                                          type="number"></el-input>
                            </el-form-item>

                            <el-form-item label="评论时间" style="margin-right: 10px !important;">
                                <el-date-picker
                                         @input="getTrend(true)"
                                        v-model="trendSelect.trend.createTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择评论时间"
                                        default-time="12:00:00">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="margin-left: 20px;" @click="reset()" type="danger">重置</el-button>
                                <el-button style="margin-left: 20px;" @click="getTrend(true)" type="primary">查询
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-col>
            </el-row>
        </div>

        <div class="table-wrapper">
            <el-table
                    :header-cell-style="$store.state.style.table.headerCellStyle"
                    :cell-style="$store.state.style.table.cellStyle"
                    :header-row-style="$store.state.style.table.headerRowStyle"
                    :row-style="$store.state.style.table.rowStyle"
                    :row-class-name="tableClass"
                    border
                    key="TrendManage"
                    width="100%"
                    :data="trends">
                <el-table-column label="主键" prop="id"></el-table-column>
                <el-table-column label="用户ID" prop="userId"></el-table-column>
                <el-table-column label="发布时间" prop="createTime"></el-table-column>
                <el-table-column label="读书笔记内容" prop="content"></el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <div style="display: flex;gap: 10px;padding: 0 10px ">
                            <img :src="$store.state.backendHost+o"
                                 style="cursor: pointer"
                                 height="50px" alt=""
                                 @click="openFullscreen($store.state.backendHost+o)"
                                 v-for="(o,i) in scope.row.imgs.split(',')"
                                 :key="i"></div>
                    </template>
                </el-table-column>
                <el-table-column width="380" label="操作">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: center;flex-direction: row">
                            <el-button v-if="role===0" type="primary" @click="handleTrendDialog(2,scope.row)"
                                       icon="el-icon-edit"></el-button>
                            <el-popover
                                    v-if="role===0 && scope.row.role !==0"
                                    placement="top"
                                    key="TrendManage"
                                    style="margin-left: 10px"
                                    v-model="scope.row.visible">
                                <p style="text-align: center">真的要删除吗?</p>
                                <div>
                                    <el-button type="danger" @click="deleteTrend(scope.row,scope.$index)">确定
                                    </el-button>
                                    <el-button type="success" @click="scope.row.visible=false">取消</el-button>
                                </div>
                                <el-button icon="el-icon-delete" type="danger" slot="reference"></el-button>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pg-wrapper">
                <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="trendSelect.pageVo.pageIndex"
                        :page-size.sync="trendSelect.pageVo.pageSize"
                        @size-change="getTrend(false)"
                        @current-change="getTrend(false)"
                        :page-sizes="[5, 10, 50, 100]"
                        :total.sync="trendSelect.pageVo.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="trendDialogVisible" width="40%" :close-on-click-modal="false">
            <el-form label-width="150px" label-position="left" :model="trend">
                <el-form-item label="用户ID" style="margin-right: 10px !important;">
                    <el-input v-model="trend.userId" type="number"></el-input>
                </el-form-item>
                <el-form-item label="读书笔记内容" style="margin-right: 10px !important;">
                    <el-input v-model="trend.content" type="text"></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <MultiImgUploader v-model="trend.imgs"></MultiImgUploader>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           <el-button @click="trendDialogVisible = false">取消</el-button>
           <el-button type="primary" @click="handleTrendDialogConfirm">保存</el-button>
       </span>
        </el-dialog>
    </div>
</template>
<script>
import MultiImgUploader from '@/components/MultiImgUploader.vue'

export default {
    name: "TrendManage",
    components: {MultiImgUploader},
    watch: {},
    data() {
        return {
            isFullscreen: false,
            fullscreenImage: '',
            role: this.$store.state.loginUser.role,
            trendSelect: {
                trend: {
                    id: null,
                    userId: 0,
                    createTime: '',
                },
                pageVo: {
                    pageSize: 5,
                    pageIndex: 1,
                    total: 0
                }
            },
            trend: {
                id: null,
                userId: 0,
                createTime: '',
                content: '',
                imgs: '',
            },
            trends: [],
            selectedTrend: {},
            trendDialogMode: 1,
            trendDialogVisible: false,
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    methods: {
        openFullscreen(image) {
            this.fullscreenImage = image;
            this.isFullscreen = true;

        },
        closeFullscreen() {
            this.isFullscreen = false;
            this.fullscreenImage = '';
        },
        reset() {
            this.trendSelect.trend = {}
            this.getTrend(true)
        },
        //crud
        insertTrend() {
            let data = JSON.stringify(this.trend)
            this.$axios({
                url: "/trend/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    this.trend.id = r.data
                    this.trends.push(this.trend)
                    this.trendSelect.pageVo.total++
                    this.$message.success('创建成功');
                } else {
                    this.$message.error('创建失败');
                }
            })
        },
        dup(o) {
            this.trend = o
            this.insertTrend()
        },
        deleteTrend(trend, index) {
            this.$axios({
                url: "/trend/delete?id=" + trend.id,
                method: 'get',
                headers: {'content-type': 'application/json'},
            }).then((r) => {
                if (r.data === 1) {
                    this.trends.splice(index, 1)
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('删除失败');
                }
            })
        },
        modifyTrend() {
            let data = JSON.stringify(this.trend)
            this.$axios({
                url: "/trend/update",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data === 1) {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
            })
        },
        getTrend(resetPageIndex) {
            if (resetPageIndex) {
                this.trendSelect.pageVo.pageIndex = 1
            }
            let data = JSON.stringify(this.trendSelect)
            this.$axios({
                url: "/trend/select",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                this.trends = r.data.trends
                this.trendSelect.pageVo.total = r.data.total
            })
        },
        //crud public
        handleTrendDialog(mode, trend) {
            this.trendDialogMode = mode
            this.trendDialogVisible = true
            if (mode === 1) {
                this.trend = {
                    id: null,
                    userId: 0,
                    createTime: '',
                    content: '',
                    imgs: '',
                }
            }
            if (mode === 2) {
                this.trend = trend
            }
        },
        handleTrendDialogConfirm() {
            if (this.trendDialogMode === 1) this.insertTrend()
            if (this.trendDialogMode === 2) this.modifyTrend()
            this.trendDialogVisible = false
        },

        //common
        tableClass({row, rowIndex}) {
            return rowIndex % 2 === 1 ? "even-row" : "no-even-row"
        },
    },
    mounted() {
        this.reset()
    },
}
</script>
<style scoped>
.el-radio-button__inner {
    border: 0 !important;
    border-radius: 0 !important;
    /*background-color: transparent !important;*/
}

.fullscreen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.fullscreen-image {
    max-width: 90%;
    max-height: 90%;
}

</style>